<template>
  <v-overlay :value="loader" light :z-index="options.zIndex">
    <v-progress-circular
      indeterminate
      :color="options.color"
      :size="60"
      :width="6"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  data: () => ({
    loader: false,
    options: {
      color: "primary",
      zIndex: "800"
    }
  }),
  methods: {
    show() {
      this.loader = true;
    },
    hide() {
      this.loader = false;
    }
  }
};
</script>
